<template>
<Bar :chart-options="chartOptions" :chart-data="chartData" :chart-id="chartId" :dataset-id-key="datasetIdKey" :plugins="plugins" :css-classes="cssClasses" :styles="styles" :width="width" :height="height" />
</template>

<script>
import {
  Bar
} from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  SubTitle,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, SubTitle, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'BarChart',
  components: {
    Bar
  },
  props: {
    chartId: {
      type: String,
      default: 'bar-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    },
    buys: {
      type: Array,
      default: () => []
    },
    sales: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      chartData: {
        labels: [
          'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'
        ],
        datasets: [{
          label: 'خرید',
          backgroundColor: 'lightblue',
          data: this.buys
        }, {
          label: 'فروش',
          backgroundColor: 'lightgreen',
          data: this.sales
        }]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            title: {
              display: true,
              text: "نمودار مقایسه ماهیانه خرید و فروش"
            }
          },
          subtitle: {
            display: true,
            position: "left",
            text: "کیلوگرم"
          }
        }
      },
    }
  }
}
</script>
